import { lazy } from "react";

export type { INicheMoreMenuContainerProps } from "./types";

export const NicheMoreMenu = lazy(() => import("./NicheMoreMenuContainer"));
